// Configuration EmailJS
// MÉTHODE 1 : Via variables d'environnement (recommandé)
const config = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
};

// MÉTHODE 2 : Valeurs en dur (fallback - à utiliser temporairement pour tester)
// Décommentez les lignes ci-dessous si process.env ne fonctionne pas
/*
const config = {
  serviceId: 'service_qkit28s',
  templateId: 'template_luv328i',
  publicKey: 'mZocg14naTtXIEfqA',
};
*/

// Validation
console.log('📧 Configuration EmailJS chargée:');
console.log('  - Service ID:', config.serviceId ? '✅' : '❌');
console.log('  - Template ID:', config.templateId ? '✅' : '❌');
console.log('  - Public Key:', config.publicKey ? '✅' : '❌');

if (!config.serviceId || !config.templateId || !config.publicKey) {
  console.error('❌ Configuration EmailJS incomplète !');
  console.error('Vérifiez votre fichier .env ou décommentez les valeurs en dur ci-dessus');
}

export default config;
